import {GET_COIN} from '../actions/coin/type'

const initState = {coin: 0}
export default function(state = initState, action) {
    switch(action.type) {
        case GET_COIN:
            const {coin} = action.payload
            return {...state, coin}
        default:
            return state
    }
}